<div class="layout-main">
  <div class="container-fluid">
    <div class="pb-2 mb-3 border-bottom">
      <h2>
        <b>Historical BW-service data request log</b>
      </h2>
    </div>
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true">
          <ng-template pTemplate="header">
            <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
          </ng-template>
          <div class="row">
            <div class="form-group col-3">
              <p-floatLabel>
                <input [(ngModel)]="historicalDataLogFilter.company" (ngModelChange)="filter()" class="form-control" id="subject"
                       pInputText type="text">
                <label for="subject">Company Name</label>
              </p-floatLabel>
            </div>
            <div class="form-group col-2">
              <p-floatLabel>
                <p-calendar [(ngModel)]="historicalDataLogFilter.dateFrom" (ngModelChange)="filter()" [disabledDays]=""
                            [showIcon]="true" dateFormat="mm/yy" view="month"></p-calendar>
                <label>Sent Date From</label>
              </p-floatLabel>
            </div>
            <div class="form-group col-2">
              <p-floatLabel>
                <p-calendar [(ngModel)]="historicalDataLogFilter.dateTo" (ngModelChange)="filter()" [showIcon]="true"
                            dateFormat="mm/yy" view="month"></p-calendar>
                <label>Sent Date To</label>
              </p-floatLabel>
            </div>
            <div class="form-group col-5" style="padding-top: 25px;">
              <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" id="download_csv_button" label="Reset"
                      pButton style="float:right; margin-left: 2px;" type="button"></button>
              <button (click)="dt.exportCSV()" icon="fa fa-download pr-2" iconPos="left" id="reset_button" label="Download csv"
                      pButton style="float:right; margin-left: 10px" type="button"></button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <div>
      <p-table #dt [columns]="cols" [paginator]="true" [rowHover]="true"
               [rows]="30" [tableStyle]="{'table-layout':'auto'}" [value]="filteredHistoricalDataRequests"
               exportFilename="{{csvFilename}}" id="downLoaded-documents-list-table">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of cols" [pSortableColumnDisabled]="!col.sortable"
                [pSortableColumn]="col.sortField || col.field"
                class="p-sortable-column ng-star-inserted">
              {{ col.header }}
              <p-sortIcon *ngIf="col.sortable" [field]="col.sortField || col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template let-historicalData pTemplate="body">
          <tr [pSelectableRow]="historicalData">
            <td>
              {{ historicalData.formattedSentAt }}
            </td>
            <td>
              {{ historicalData.path }}
            </td>
            <td>
              {{ historicalData.formattedAvailable }}
            </td>
            <td>
              {{ historicalData.period }}
            </td>
            <td>
              {{ historicalData.userName }}
            </td>
            <td>
              {{ historicalData.email }}
            </td>
            <td>
              {{ historicalData.companyName }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          {{ records }} results
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
